import { useEffect, useState } from 'react';
import { useAuth } from '../lib/auth-context';
import { useEnterpriseOrg } from '../context/EnterpriseOrgContext';
import {
  type EnterpriseWorkspaceObservability,
} from '../lib/enterprise-api';
import { loadWorkspaceObservability } from '../lib/enterprise-work-engine';

export function useEnterpriseWorkspaceObservability() {
  const { accessToken } = useAuth();
  const { activeOrgId, hasActiveOrgAccess } = useEnterpriseOrg();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<EnterpriseWorkspaceObservability | null>(null);

  useEffect(() => {
    let cancelled = false;
    if (!accessToken || !activeOrgId || !hasActiveOrgAccess) {
      setData(null);
      setError(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    void loadWorkspaceObservability(accessToken, activeOrgId)
      .then((res) => {
        if (cancelled) return;
        if (!res.success || !res.data) {
          setData(null);
          setError(res.error || 'Failed to load observability data');
          return;
        }
        setData(res.data);
      })
      .catch((e) => {
        if (cancelled) return;
        setData(null);
        setError(e instanceof Error ? e.message : String(e));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [accessToken, activeOrgId, hasActiveOrgAccess]);

  return { loading, error, data };
}

